import { render, staticRenderFns } from "./PrintSectionCustomizer.vue?vue&type=template&id=164404c3&scoped=true&"
import script from "./PrintSectionCustomizer.vue?vue&type=script&lang=js&"
export * from "./PrintSectionCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./PrintSectionCustomizer.vue?vue&type=style&index=0&id=164404c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164404c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VBtnToggle,VCard,VChip,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon,VSlider,VSwitch})
